import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';
import {LoginComponent} from './auth/login/login.component';
import {WebUtils} from './utils/web.utils';

export class CustomReuseStrategy implements RouteReuseStrategy {
  readonly DEFAULT_CACHED_ROUTES = ['discover', 'discover/posts', 'discover/influencers'];
  routesToCache: string[] = ['discover', 'discover/posts', 'discover/influencers'];
  storedRouteHandles = new Map<string, DetachedRouteHandle>();
  private currentActiveCompany: number;
  constructor() {
    this.currentActiveCompany = Number(WebUtils.extractQueryParams('activeAccount'));
  }

  updateRouteToCache(route) {
    if (this.routesToCache.indexOf(route) < 0) {
      this.routesToCache.push(route);
    }
  }

  resetCachedRoutes() {
    this.routesToCache = [];
    this.routesToCache.push(...this.DEFAULT_CACHED_ROUTES);
  }

  // Decides if the route should be stored
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (!route.routeConfig) {
      return false;
    }
    const pathDetails = this.getResolvedUrl(route);
    return this.routesToCache.indexOf(pathDetails) > -1;
  }

  // Store the information for the route we're destructing
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (!route.routeConfig) {
      return;
    }
    const pathDetails = this.getResolvedUrl(route);
    this.storedRouteHandles.set(pathDetails, handle);
  }

  // Return true if we have a stored route object for the next route
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (!route.routeConfig) {
      return false;
    }
    if (route.component === LoginComponent) {
      this.storedRouteHandles = new Map<string, DetachedRouteHandle>();
      return false;
    }
    const activeCompany = Number(WebUtils.extractQueryParams('activeAccount'));
    if (activeCompany && this.currentActiveCompany !== activeCompany) {
      this.storedRouteHandles = new Map<string, DetachedRouteHandle>();
      this.currentActiveCompany = activeCompany;
      return false;
    }
    const pathDetails = this.getResolvedUrl(route);
    return this.storedRouteHandles.has(pathDetails);
  }

  // If we returned true in shouldAttach(), now return the actual route data for restoration
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!route.routeConfig) {
      return null;
    }
    const pathDetails = this.getResolvedUrl(route);
    return this.storedRouteHandles.get(pathDetails);
  }

  // Reuse the route if we're going to and from the same route
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .filter(v => v.url.length > 0)
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
  }
}



// WEBPACK FOOTER //
// ./src/app/routing.ts